import { ContextService } from "./context.service";
import { Configuration } from "../../shared/models/configuration.model";
import { Organization } from "../../shared/models/organization.model";
import { getResult } from "./services.utils";

/***
 * This is the standard backend implementation that uses the API server to get data.
 */
export class ContextServiceImpl implements ContextService {
    appAPIUrl: string;
    showSnackbar: (message: string, severity: string) => void;

    constructor(appAPIUrl: string, showSnackbar: (message: string, severity: string) => void) {
        this.appAPIUrl = appAPIUrl;
        this.showSnackbar = showSnackbar;
    }
    public getConfiguration = async (
        site: string,
        id: string,
    ): Promise<Configuration> => {
        const res = await fetch(`${this.appAPIUrl}/configuration/${site}/${id}`, {
            method: "GET",
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return getResult(res, false, this.showSnackbar);
    }

    public getOrganization = async (
        site: string,
        id: string,
    ): Promise<Organization> => {
        const res = await fetch(`${this.appAPIUrl}/organization/${site}/${id}`, {
            method: "GET",
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return getResult(res, false, this.showSnackbar);
    }
}
